import React, { useContext } from 'react'

import AppContext from './AppContext'
import CurrencyFormat from 'react-currency-format'

const TotalRow = ({ total, currency }) => {
  const myContext = useContext(AppContext)
  return (
    <div className="flex flex-row justify-between mt-14 font-mono">
      <div className="w-1/3"></div>
      <div className="w-1/6"></div>
      <div className="w-1/6 text-right">Subtotal</div>
      <div className="w-1/6 text-right font-mono">
        <CurrencyFormat
          value={total}
          displayType={'text'}
          thousandSeparator={true}
          decimalScale={2}
          fixedDecimalScale={true}
          prefix={currency || myContext.currency}
        />
      </div>
    </div>
  )
}

export default TotalRow
